const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  login: `${apiUrl}/v2/auth/login`,
  logout: `${apiUrl}/session`,
  destroySession: `${apiUrl}/v2/auth/session/destroy`,
};
